import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

const prose =
  "text-pretty text-base leading-relaxed text-slate-600 dark:text-slate-400";

function PrivacyPolicy() {
  const { t } = useTranslation();

  const sections = useMemo(
    () => [
      {
        id: "privacy-scope",
        title: t("privacyPolicy.scope.title"),
        content: [
          { type: "text", value: t("privacyPolicy.scope.text1") },
          { type: "text", value: t("privacyPolicy.scope.text2") },
        ],
      },
      {
        id: "privacy-access",
        title: t("privacyPolicy.accessData.title"),
        content: [
          { type: "text", value: t("privacyPolicy.accessData.text1") },
          {
            type: "list",
            items: t("privacyPolicy.accessData.list", { returnObjects: true }),
          },
          { type: "text", value: t("privacyPolicy.accessData.text2") },
        ],
      },
      {
        id: "privacy-cookies",
        title: t("privacyPolicy.cookies.title"),
        content: [
          { type: "text", value: t("privacyPolicy.cookies.text1") },
          { type: "text", value: t("privacyPolicy.cookies.text2") },
        ],
      },
      {
        id: "privacy-personal",
        title: t("privacyPolicy.personalData.title"),
        content: [
          { type: "text", value: t("privacyPolicy.personalData.text1") },
          { type: "text", value: t("privacyPolicy.personalData.text2") },
        ],
      },
      {
        id: "privacy-contact",
        title: t("privacyPolicy.contactData.title"),
        content: [{ type: "text", value: t("privacyPolicy.contactData.text") }],
      },
      {
        id: "privacy-rights",
        title: t("privacyPolicy.userRights.title"),
        content: [{ type: "text", value: t("privacyPolicy.userRights.text") }],
      },
    ],
    [t]
  );

  return (
    <section
      className="border-t border-slate-200 bg-white py-12 transition-colors dark:border-slate-700 dark:bg-slate-800 md:py-14"
      id="privacy-policy"
      aria-labelledby="privacy-policy-heading"
    >
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h2
          id="privacy-policy-heading"
          className="scroll-mt-28 text-pretty text-3xl font-semibold tracking-tight text-primary dark:text-primary-light md:text-4xl"
        >
          {t("privacyPolicy.title")}
        </h2>
        <p
          className="mt-2 text-sm text-slate-500 dark:text-slate-400"
          aria-hidden
        >
          <span className="inline-block h-0.5 w-12 rounded-full bg-primary dark:bg-primary-light" />
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-slate-200 bg-slate-50/40 shadow-sm dark:border-slate-600 dark:bg-slate-900/30">
          {sections.map((section, index) => (
            <article
              key={section.id}
              id={section.id}
              className={`scroll-mt-28 border-t border-slate-200 p-6 sm:p-8 dark:border-slate-600 ${
                index === 0 ? "border-t-0" : ""
              }`}
            >
              <h3 className="mb-4 text-lg font-semibold tracking-tight text-slate-900 dark:text-slate-100">
                {section.title}
              </h3>
              <div className="space-y-4">
                {section.content.map((item, itemIndex) => {
                  if (item.type === "text") {
                    return (
                      <p key={itemIndex} className={prose}>
                        {item.value}
                      </p>
                    );
                  }
                  if (item.type === "list") {
                    const items = Array.isArray(item.items) ? item.items : [];
                    return (
                      <ul
                        key={itemIndex}
                        className={`${prose} list-outside space-y-2 pl-5 marker:text-primary dark:marker:text-primary-light`}
                      >
                        {items.map((listItem, listIndex) => (
                          <li key={listIndex} className="pl-1 leading-relaxed">
                            {listItem}
                          </li>
                        ))}
                      </ul>
                    );
                  }
                  return null;
                })}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
